// Mock data for Tom The Window Cleaner website

export const contactInfo = {
  phone: '0758 333 1372',
  email: 'info@tomthewindowcleaner.co.uk',
  address: 'Neath, West Glamorgan, Wales',
  serviceRadius: 'Approx 20 miles from Neath'
};

export const pricingData = {
  windowCleaning: [
    {
      id: 1,
      category: 'Front Only',
      price: '£12-£15',
      description: 'Front windows only service',
      features: ['All front-facing windows', 'UPVC frames and sills cleaned', 'Quick service', 'Perfect for regular maintenance']
    },
    {
      id: 2,
      category: '2-3 Bedroom Property',
      price: '£18-£22',
      description: 'Standard property cleaning',
      features: ['All glass, doors, UPVC window frames and sills cleaned as standard', 'External windows', 'Streak-free finish']
    },
    {
      id: 3,
      category: '4 Bedroom Property',
      price: '£20-£30',
      description: 'Larger property service',
      features: ['All glass, doors, UPVC window frames and sills cleaned as standard', 'External windows', 'Additional rooms covered', 'Streak-free finish']
    },
    {
      id: 4,
      category: '4-5 Bedroom Executive Property',
      price: '£30+',
      description: 'Executive property service',
      features: ['All glass, doors, UPVC window frames and sills cleaned as standard', 'External windows', 'Large property coverage', 'Extended service time']
    }
  ],
  gutterClearing: [
    {
      id: 1,
      category: '2-3 Bedroom Property',
      price: '£50-£70',
      description: 'Standard gutter clearing',
      features: ['Ground-level clearing using professional gutter vac system', 'Complete debris removal from gutters', 'No ladders required - safer for everyone', 'Disposal of all waste included']
    },
    {
      id: 2,
      category: '4 Bedroom Property',
      price: '£60-£100',
      description: 'Larger property gutter clearing',
      features: ['Ground-level clearing using professional gutter vac system', 'Complete debris removal from gutters', 'No ladders required - safer for everyone', 'Disposal of all waste included', 'Extended guttering covered']
    },
    {
      id: 3,
      category: '4-5 Bedroom Executive Property',
      price: '£80-£120',
      description: 'Executive property gutter clearing',
      features: ['Ground-level clearing using professional gutter vac system', 'Complete debris removal from gutters', 'No ladders required - safer for everyone', 'Disposal of all waste included', 'Large property coverage']
    }
  ],
  gutterCleaning: [
    {
      id: 1,
      category: '2-3 Bedroom Property',
      price: '£50-£70',
      description: 'Standard gutter cleaning',
      features: ['Washing down guttering, fascia boards and downpipes', 'Professional cleaning of exterior gutter surfaces', 'Removes dirt, moss and grime', 'Enhanced curb appeal']
    },
    {
      id: 2,
      category: '4 Bedroom Property',
      price: '£60-£100',
      description: 'Larger property gutter cleaning',
      features: ['Washing down guttering, fascia boards and downpipes', 'Professional cleaning of exterior gutter surfaces', 'Removes dirt, moss and grime', 'Enhanced curb appeal', 'Extended guttering covered']
    },
    {
      id: 3,
      category: '4-5 Bedroom Executive Property',
      price: '£80-£120',
      description: 'Executive property gutter cleaning',
      features: ['Washing down guttering, fascia boards and downpipes', 'Professional cleaning of exterior gutter surfaces', 'Removes dirt, moss and grime', 'Enhanced curb appeal', 'Large property coverage']
    }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: 'Window Cleaning',
    description: 'Professional window cleaning services for residential and commercial properties. We use purified water systems and traditional methods to ensure streak-free, spotless windows every time.',
    features: [
      'Inside and outside cleaning',
      'Purified water system for streak-free finish',
      'Traditional squeegee methods available',
      'Window sills and frames included',
      'Regular maintenance schedules available',
      'Safe working at height with proper equipment'
    ],
    image: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/a7kwrzoz_IMG_7308.jpeg'
  },
  {
    id: 2,
    title: 'Gutter Cleaning',
    description: 'Keep your gutters flowing freely with our comprehensive gutter service. We provide both gutter clearing (removing all debris, leaves, and blockages) and gutter cleaning (washing down the guttering, fascia boards, and downpipes). We use professional gutter vac equipment to safely empty gutters from ground level - on pretty much every gutter clean we do, there is no need for ladders. This complete approach prevents water damage, keeps your property looking its best, and provides peace of mind with our safer working methods.',
    features: [
      'Ground-level gutter clearing using professional gutter vac system',
      'No ladders required on most jobs - safer for employees and customers',
      'Complete debris removal (gutter clearing)',
      'Washing down guttering, fascia boards and downpipes (gutter cleaning)',
      'Downpipe clearing',
      'Gutter inspection included',
      'Prevention of water damage',
      'Disposal of all waste'
    ],
    image: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/2xfr23qq_IMG_7342.jpeg'
  },
  {
    id: 3,
    title: 'Pressure Washing',
    description: 'Revitalize your driveways, patios, and exterior surfaces with our professional pressure washing service. We remove dirt, moss, algae, and years of grime to restore surfaces to their former glory.',
    features: [
      'Driveways and paths',
      'Patios and decking',
      'Building exteriors',
      'Moss and algae removal',
      'Professional equipment',
      'Environmentally friendly cleaning'
    ],
    image: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/645sb322_IMG_9169.jpeg'
  },
  {
    id: 4,
    title: 'Soft Washing',
    description: 'Soft washing is a gentle yet highly effective cleaning method that uses low-pressure water combined with specialized biodegradable cleaning solutions to safely remove organic stains, algae, mold, mildew, moss, and lichen from delicate exterior surfaces. Unlike high-pressure washing which can damage sensitive materials, soft washing treats the root cause of contamination and provides longer-lasting results. This method is ideal for roofs, render, painted surfaces, UPVC cladding, and other areas where traditional pressure washing could cause harm.',
    features: [
      'Low-pressure cleaning - safe for delicate surfaces',
      'Specialized biodegradable cleaning solutions',
      'Removes algae, mold, mildew, moss and lichen',
      'Ideal for roofs, render, painted surfaces and UPVC',
      'Kills organic growth at the root for longer-lasting results',
      'Prevents damage to tiles, shingles, and painted finishes',
      'Eco-friendly and safe for plants and landscaping',
      'Extends the life of your roof and exterior surfaces'
    ],
    image: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/el4p516w_IMG_3790.jpeg',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/el4p516w_IMG_3790.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/d3dwqz2m_IMG_3793.jpeg'
    ]
  },
  {
    id: 5,
    title: 'Solar Panel Cleaning',
    description: 'Professional solar panel cleaning services to maximize your energy output and protect your investment. Dirty solar panels can lose 15-25% of their efficiency due to dust, bird droppings, pollen, and atmospheric pollution. Our specialized cleaning process safely removes all contaminants without damaging the delicate photovoltaic cells, ensuring your panels operate at peak performance. Regular cleaning not only increases energy production but also extends the lifespan of your solar system and helps you get the best return on your investment.',
    features: [
      'Increases energy output by up to 25%',
      'Specialized cleaning methods safe for photovoltaic cells',
      'Purified water system prevents mineral deposits',
      'No harsh chemicals that could damage panels',
      'Extends the lifespan of your solar investment',
      'Professional equipment for safe rooftop access',
      'Inspection for damage or potential issues',
      'Regular maintenance schedules available'
    ],
    image: 'https://images.unsplash.com/photo-1754619880959-2b0528375883?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVsJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzY5Mjc1NDIwfDA&ixlib=rb-4.1.0&q=85'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/apv95sad_IMG_6840.jpeg',
    title: 'Residential Window Cleaning',
    description: 'Professional water-fed pole system for spotless results'
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/0z4zbzbf_IMG_7290.jpeg',
    title: 'Commercial Window Cleaning',
    description: 'Professional service for commercial buildings'
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/tndd3ot8_IMG_1186.png',
    title: 'Abseil Window Cleaning',
    description: 'Specialist rope access for high-level commercial buildings'
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/9cn7rxgc_IMG_5695.jpeg',
    title: 'Residential Pressure Washing',
    description: 'Transforming driveways and patios - before & after results',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/9cn7rxgc_IMG_5695.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/dsj1cyfn_IMG_5722.jpg'
    ]
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/blj9ebhx_IMG_7873.jpeg',
    title: 'Commercial Pressure Washing',
    description: 'Professional render and cladding cleaning for commercial buildings'
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/fooq6muo_IMG_7893.jpeg',
    title: 'Abseil Pressure Washing',
    description: 'Removing algae and stains from building facades at height'
  },
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/6z34wdg5_IMG_0567.jpeg',
    title: 'Residential Soft Washing',
    description: 'Restoring render and removing years of algae build-up',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/6z34wdg5_IMG_0567.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/gz5lqhub_IMG_0573.jpeg'
    ]
  },
  {
    id: 8,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/arvw9f2q_IMG_3481.jpeg',
    title: 'Commercial Soft Washing',
    description: 'Professional render cleaning for commercial properties',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/arvw9f2q_IMG_3481.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/xgrtj6ji_IMG_3482.jpeg'
    ]
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/wm45kx2l_IMG_3477.jpeg',
    title: 'Residential Soft Washing',
    description: 'Dramatic transformations from heavily stained to spotless',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/wm45kx2l_IMG_3477.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/qez8kyhs_IMG_3478.jpeg'
    ],
    verticalLayout: true
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/5pbi19c9_IMG_6343.jpeg',
    fullWidthRow: true
  },
  {
    id: 11,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/8h1d4958_IMG_5809.jpeg',
    fullWidthRow: true
  },
  {
    id: 12,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/pq6pnyeo_IMG_6191.jpeg',
    fullWidthRow: true
  },
  {
    id: 13,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/a72j0vtg_IMG_3799.jpeg',
    fullWidthRow: true
  },
  {
    id: 14,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/w7h9qsfy_IMG_6026.jpg',
    fullWidthRow: true
  },
  {
    id: 15,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/3xb8m48k_IMG_6648.jpeg',
    fullWidthRow: true
  },
  {
    id: 16,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/yebidyxi_IMG_2272.jpeg',
    fullWidthRow: true
  },
  {
    id: 17,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/ghgi4z0g_IMG_5810.jpeg',
    fullWidthRow: true
  },
  {
    id: 18,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/5kzwyn6r_IMG_6651.jpeg',
    fullWidthRow: true
  },
  {
    id: 19,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/um2irwch_IMG_2358.jpeg',
    fullWidthRow: true
  },
  {
    id: 20,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/cdkqkksd_IMG_5625.jpeg',
    fullWidthRow: true
  },
  {
    id: 21,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/cua30fb3_IMG_4816.jpeg',
    fullWidthRow: true
  },
  {
    id: 22,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/i2n70qk1_IMG_7544.jpeg',
    fullWidthRow: true
  },
  {
    id: 23,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/zng40k12_IMG_5720.jpg',
    fullWidthRow: true
  },
  {
    id: 24,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/vqp5nu6q_IMG_2571.jpeg',
    fullWidthRow: true
  },
  {
    id: 25,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/yoayfbdn_IMG_2572.jpeg',
    fullWidthRow: true
  },
  {
    id: 26,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/majq2r3p_IMG_5865.jpeg',
    fullWidthRow: true
  },
  {
    id: 27,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/k0pzsvpq_IMG_6083.jpeg',
    fullWidthRow: true
  },
  {
    id: 28,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/p41x3yin_IMG_6099.jpeg',
    fullWidthRow: true
  },
  {
    id: 29,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/np7hr6wy_IMG_6188.jpeg',
    fullWidthRow: true
  },
  {
    id: 30,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/3zhey5rp_IMG_5891.jpeg',
    title: 'Residential Gutter Cleaning',
    description: 'Washing down guttering, fascia boards and downpipes for a fresh clean finish'
  },
  {
    id: 31,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/lp4jbhzx_IMG_3799.jpeg',
    title: 'Residential Gutter Clearing',
    description: 'Removing leaves and debris with our professional ground-level vacuum system'
  },
  {
    id: 32,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/uex4i7o2_IMG_1202.jpeg',
    title: 'Residential Solar Panel Cleaning',
    description: 'Maximizing energy efficiency with professional solar panel cleaning'
  },
  {
    id: 33,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/48nrdgvd_IMG_6649.jpeg',
    title: 'Patio Cleaning',
    description: 'Transforming outdoor spaces to a professional standard',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/48nrdgvd_IMG_6649.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/tdwmu059_IMG_6651.jpeg'
    ]
  },
  {
    id: 34,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/jab83q96_IMG_6864.jpeg',
    title: 'Professional Pressure Washing',
    description: 'Restoring surfaces to their original beauty',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/jab83q96_IMG_6864.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/tk8lnm69_IMG_6873.jpg'
    ]
  },
  {
    id: 35,
    url: 'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/4um0kd43_IMG_6893.jpeg',
    title: 'Internal Window Cleaning',
    description: 'Frames and sills cleaned to perfection every time',
    beforeAfterImages: [
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/4um0kd43_IMG_6893.jpeg',
      'https://customer-assets.emergentagent.com/job_crystal-clean-3/artifacts/0xnt2l3n_IMG_6892.jpeg'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Williams',
    location: 'Neath',
    rating: 5,
    text: 'Tom does an excellent job every time. My windows have never looked better! Highly recommended.'
  },
  {
    id: 2,
    name: 'David Jones',
    location: 'Port Talbot',
    rating: 5,
    text: 'Very professional service. Always on time and does a thorough job. Been using Tom for over 2 years now.'
  },
  {
    id: 3,
    name: 'Emma Thomas',
    location: 'Skewen',
    rating: 5,
    text: 'Fantastic service! Tom cleaned our conservatory roof and it looks brand new. Great value for money.'
  }
];

export const coverageAreas = [
  'Aberdulais',
  'Aberavon',
  'Abergarwed',
  'Alltwen',
  'Baglan',
  'Briton Ferry',
  'Bryn',
  'Bryncoch',
  'Cadoxton',
  'Cilybebyll',
  'Clydach',
  'Crynant',
  'Cwmavon',
  'Glynneath',
  'Godre\'r Graig',
  'Gower',
  'Killay',
  'Llandarcy',
  'Mumbles',
  'Neath',
  'Pontardawe',
  'Pontrhydyfen',
  'Port Talbot',
  'Porthcawl',
  'Pyle',
  'Resolven',
  'Rhos',
  'Seven Sisters',
  'Sketty',
  'Skewen',
  'Swansea',
  'Tonna',
  'Ystalyfera'
];
